const genRandomNum = (limit) => Math.floor(Math.random() * limit);
export default genRandomNum;